import React from "react";
import CareerDetail from "../components/Careerdetail/Careerdetail";
import data from '../json/Careerdetail/openings.json'

const Careerdetail = () => {
  return (
    <div className="w-full flex flex-col items-center gap-5 lg:gap-[72px] ruler">
      {/* <Careerdetail1 /> */}
      <CareerDetail data={data}/>
    </div>
  );
};

export default Careerdetail;
